import React from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Table } from 'antd';
import { PRETTY_DATE_FORMAT } from '@owl-frontend/components';
import { ClaimDetailsContext } from '../ClaimDetailsContext';
import styles from './ClaimMetadataComponent.module.scss';

dayjs.extend(utc);
const hasDate = /_date/;
const PRETTY_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const isDate = (value: string): boolean => {
  return hasDate.test(value);
};
const ClaimMetadataComponent = () => {
  const { claimMetadata } = React.useContext(ClaimDetailsContext);

  const dataSource = React.useMemo(() => {
    if (!claimMetadata?.claimant_metadata_dict) {
      return [];
    }
    return Object.keys(claimMetadata.claimant_metadata_dict).map(
      (attributeKey, index) => {
        const attribute = claimMetadata.claimant_metadata_dict![attributeKey];
        let displayValue = attribute.value;

        if (isDate(attributeKey) && dayjs(attribute.value).isValid()) {
          if (PRETTY_DATE_REGEX.test(attribute.value)) {
            displayValue = dayjs(attribute.value).format(PRETTY_DATE_FORMAT);
          } else {
            displayValue = dayjs
              .utc(attribute.value)
              .format(PRETTY_DATE_FORMAT);
          }
        }

        return {
          key: index,
          display_name: attribute.display_name,
          value: displayValue || '-',
        };
      }
    );
  }, [claimMetadata?.claimant_metadata_dict]);

  return (
    <div className={styles.claimMetadataContainer}>
      <Table
        className={styles.claimMetadataTable}
        dataSource={dataSource}
        columns={[
          {
            title: 'Attribute',
            dataIndex: 'display_name',
            key: 'display_name',
          },
          {
            title: 'Value',
            dataIndex: 'value',
            key: 'value',
          },
        ]}
        pagination={false}
        size="small"
      />
    </div>
  );
};

export default ClaimMetadataComponent;
